import React from "react";
import { useTranslation } from "@helpers/translate";
import CardButton from "../buttons/CardButton";
import BinifyLogo from "@components/library/Icons/BinifyLogo";
import { useDispatch } from "react-redux";
import { toggleSignUpModal } from "@actions/authModalsActions";
import "./CallToAction.sass";

const CallToAction = () => {
  const { __ } = useTranslation();
  const dispatch = useDispatch();

  const handleTryDemo = () => {
    dispatch(toggleSignUpModal(true));
  };

  return (
    <section id="contact" className="call-to-action padding-container">
      <div className="call-to-action__content">
        <div className="call-to-action__logo-mobile">
          <BinifyLogo width={"120"} height={"22"} />
        </div>
        <div className="call-to-action__logo-desktop">
          <BinifyLogo width={"206"} height={"38"} />
        </div>
        <p className="call-to-action__text text-storm-gray">
          {__("main.cta.text")}
        </p>

        <CardButton
          variant="primary"
          className="call-to-action__button"
          onClick={handleTryDemo}
          icon={
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.53125 10.75L10.5313 0.75M0.53125 0.75H10.5313V10.75"
                stroke="white"
                stroke-width="1.5"
              />
            </svg>
          }
        >
          {__("main.cta.tryFreeDemo")}
        </CardButton>
      </div>
    </section>
  );
};

export default CallToAction;
